import memoizeOne from 'memoize-one';
export var eventCpusPlugin = memoizeOne(function () {
  if (!navigator.hardwareConcurrency) {
    return null;
  }
  return {
    'event:cpus': navigator.hardwareConcurrency
  };
});